export default "__VITE_ASSET__0bdd12d2__"